import { Property } from "./property";
import { MotionRange } from "./range/motionrange";

export class MotionProperty extends Property{

    motionrange:MotionRange[];
}